import axios from "axios";

/**
 * Axios Instance for baseURL
 * TODO: change the baseURL dynamically
 */
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  timeout: 10000,
});

const createDynamicMethodWithHeaders =
  (method: string) =>
  (url: string, data: any = null, headers = {}, config = {}) => {
    const token = localStorage.getItem("token");

    const mergedHeaders = {
      ...(token && { Authorization: `Bearer ${token}` }),
      ...headers,
    };

    return axiosInstance({
      method,
      url,
      data,
      headers: mergedHeaders,
      ...config,
    });
  };

const getWithHeaders = createDynamicMethodWithHeaders("GET");
const postWithHeaders = createDynamicMethodWithHeaders("POST");
const putWithHeaders = createDynamicMethodWithHeaders("PUT");
const delWithHeaders = createDynamicMethodWithHeaders("DELETE");
const patchWithHeaders = createDynamicMethodWithHeaders("PATCH");

export {
  getWithHeaders as get,
  postWithHeaders as post,
  putWithHeaders as put,
  delWithHeaders as del,
  patchWithHeaders as patch,
};
